module.exports = __webpack_public_path__ + "media/images/expert__placeholder--left-afe1199c88fd57f593a96cc15f8a43e9.png";